import { Row } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { usePermissions } from "../../../../../../../lib/hooks/usePermissions";
import { useCallback } from "react";
import { useDownloadAttachment } from "../../../../../../../lib/hooks/useDownloadAttachment";
import DocumentsService from "../../../../../../../services/accounts/documents";

type TableActionsProps = {
  id: string;
  uploaded: boolean;
  fileName: string;
  openDocument: (id: string) => void;
  onDeleteBtnClick: (id: string) => void;
};

export const TableActions = ({
  id,
  uploaded,
  fileName,
  openDocument,
  onDeleteBtnClick,
}: TableActionsProps) => {
  const { hasAccessByController } = usePermissions("ContractDocuments");

  const { isLoading, onDownload } = useDownloadAttachment(DocumentsService);

  const onEdit = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      openDocument(id);
    },
    [id, openDocument],
  );

  const onDownloadClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, fileName: string) => {
      e.stopPropagation();
      onDownload(id, fileName);
    },
    [id, onDownload],
  );

  const onDelete = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      onDeleteBtnClick(id);
    },
    [id, onDeleteBtnClick],
  );

  return (
    <Row className="w-100 h-100 ant-table-actions justify-end pr-4">
      {uploaded && (
        <DownloadOutlined
          className="ant-table-btn logo-cursor"
          onClick={(e) => onDownloadClick(e, fileName)}
        />
      )}
      {hasAccessByController("Modify") && (
        <EditOutlined
          className="ant-table-btn logo-cursor"
          onClick={onEdit}
          disabled={isLoading}
        />
      )}
      {hasAccessByController("Delete") && (
        <DeleteOutlined
          className="ant-table-btn logo-cursor"
          onClick={onDelete}
          disabled={isLoading}
        />
      )}
    </Row>
  );
};
